import { Injectable } from '@angular/core';
import { remove } from 'lodash-es';
import { ReplaySubject } from 'rxjs';

import { TranslationService } from 'app/core/internationalization/translation.service';
import { ClassInfo } from 'app/teacher/models/class-info';
import { CreatedClassInfoModel } from 'app/teacher/models/created-class-info.model';

@Injectable({
  providedIn: 'root'
})
export class ClassesService {
  private classesSubject = new ReplaySubject<ClassInfo[]>(1);
  private _classes: ClassInfo[] = [];

  public classes$ = this.classesSubject.asObservable();

  constructor(private readonly _translationService: TranslationService) { }

  public setClasses(list: ClassInfo[]): void {
    this._classes = list;
    this.classesUpdated();
  }

  public addClass(classInfo: CreatedClassInfoModel): void {
    const newInfo: ClassInfo = {
      ...this.getDefaultClassInfo(),
      Year: classInfo.DefaultYear ?? '',
      ClassId: classInfo.ClassId,
      Name: classInfo.Name,
      TeacherName: classInfo.TeacherName,
      Courses: classInfo.Courses,
      ClassPin: classInfo.ClassPin,
      IsPremium: classInfo.IsPremium,
      ItemOrder: classInfo.ItemOrder,
      CountryCode: classInfo.CountryCode,
      NumStudents: classInfo.NumStudents,
      IsTransient: classInfo.IsTransient
    } as ClassInfo;

    this._classes.push(newInfo);
    this.classesUpdated();
  }

  public removeClassById(classId: string): void {
    remove(this._classes, ({ ClassId }) => ClassId === classId);
    this.classesUpdated();
  }

  public removeDemoClasses(): void {
    remove(this._classes, ({ IsDemo }) => IsDemo);
    this.classesUpdated();
  }

  public classesUpdated(): void {
    this.classesSubject.next([...this._classes]);
  }

  public getDefaultClassInfo(): Partial<ClassInfo> {
    const localeId = this._translationService.getCurrentLanguage();

    return {
      IsSubscribed: false,
      IsInTrialPeriod: false,
      IsRegistrationClosed: false,
      HasMathalon: true,
      IsCalculatorEnabled: false,
      IsMathalonInfluencer: false,
      NumStudentsWithParents: 0,
      NumStudentsWithoutParents: 0,
      ExpiryDate: '',
      AllowUntracked: false,
      IsContentUnlocked: true,
      IsActive: false,
      IsCurrentTerm: true,
      Year: '',
      AutoSharedMilestones: false,
      HasPremiumClass: true,
      ExternalAuthenticationType: '',
      ExternalAuthenticationId: '',
      LocaleId: localeId,
      ClassLocaleId: localeId,
      NumPendingStudentGaps: 0,
      IsUsingRedemptionCode: false,
      IsSchoolAdministrator: false,
      IsTransient: false
    };
  }
}
